import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import Services from './components/Services';
import Benefits from './components/Benefits';
import About from './components/About';
import Portfolio from './components/Portfolio';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}>
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <img 
                src="https://public.readdy.ai/ai/img_res/8f7550d7-05e5-465e-a420-21009237d9c6.png" 
                alt="Logo firmy osuszania i remontów" 
                className="h-12 w-auto object-contain"
              />
            </div>
            
            <div className="hidden md:flex items-center space-x-8">
              <button 
                onClick={() => scrollToSection('services')}
                className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  isScrolled ? 'text-gray-700 hover:text-blue-600' : 'text-white hover:text-blue-200'
                }`}
              >
                Usługi
              </button>
              <button 
                onClick={() => scrollToSection('about')}
                className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  isScrolled ? 'text-gray-700 hover:text-blue-600' : 'text-white hover:text-blue-200'
                }`}
              >
                O nas
              </button>
              <button 
                onClick={() => scrollToSection('portfolio')}
                className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  isScrolled ? 'text-gray-700 hover:text-blue-600' : 'text-white hover:text-blue-200'
                }`}
              >
                Realizacje
              </button>
              <button 
                onClick={() => scrollToSection('contact')}
                className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  isScrolled ? 'text-gray-700 hover:text-blue-600' : 'text-white hover:text-blue-200'
                }`}
              >
                Kontakt
              </button>
            </div>

            <div className="flex items-center space-x-4">
              <a 
                href="tel:+48691284309"
                className={`hidden lg:flex items-center space-x-2 text-sm font-medium whitespace-nowrap ${
                  isScrolled ? 'text-gray-700' : 'text-white'
                }`}
              >
                <i className="ri-phone-line text-lg"></i>
                <span>+48 691 284 309</span>
              </a>
              <button 
                onClick={() => scrollToSection('contact')}
                className={`px-6 py-2 rounded-lg text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                  isScrolled 
                    ? 'border-2 border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white' 
                    : 'border-2 border-white text-white hover:bg-white hover:text-blue-600'
                }`}
              >
                Bezpłatna Wycena
              </button>
            </div>
          </div>
        </div>
      </nav>

      <Hero />
      <Services />
      <Benefits />
      <About />
      <Portfolio />
      <ContactForm />
      <Footer />
    </div>
  );
}